import { render, staticRenderFns } from "./TOS.vue?vue&type=template&id=7e46e399&"
import script from "./TOS.vue?vue&type=script&lang=js&"
export * from "./TOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports